export interface PermissionGraphVersioned {
  permissionGraphVersion?: number | null;
}

export function getPermissionGraphSnapshotVersion(
  records: readonly PermissionGraphVersioned[]
): number {
  return Math.max(
    0,
    ...records.map(record => record.permissionGraphVersion ?? 0)
  );
}

export function shouldIgnorePermissionGraphSnapshot(
  incomingVersion: number,
  currentVersion: number
): boolean {
  return incomingVersion > 0 && incomingVersion < currentVersion;
}

export function mergePermissionGraphVersion(
  currentVersion: number,
  incomingVersion: number
): number {
  return Math.max(currentVersion, incomingVersion);
}
